module.exports = __webpack_public_path__ + "85b75758a7f6cb683ee9a8749822199c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pattern/9.svg
// module id = 704
// module chunks = 0